const isObj = require('lodash.get');

export const getFirmWareLists = (state) => isObj(state, 'firmwareLists', []);
export const getFirmWareListsById = (state) => isObj(state, ' firmwareListsById', []);
